var app = angular.module('app-account-service', ['ngCookies','app-cart-service']);

app.service('accountService', ['$http', '$window', '$q', '$cookies', 'cartService', function ($http, $window, $q, $cookies, cartService) {
    var factory = {};
    factory._account = {};
    factory._account.result = {};

    factory.Login = function (email, password, expanded, force) {
        if (expanded == undefined) {
            expanded = false;
        }
        //force needed to login from none masterdomain
        if (force == undefined) {
            force = false;
        }
        var def = $q.defer();
        var token = $cookies.get('accountToken') != undefined ? $cookies.get('accountToken') : '';

        //if (token.length > 0 || (email != undefined && email.length > 0 && password != undefined && password.length > 0)) {
        if (force == false && token.length > 0) {
            //already logged in
            factory._account.result.Token = token;
            def.resolve();
        } else if ((email != undefined && email.length > 0 && password != undefined && password.length > 0) || force == true) {
            cartService.MasterDomain().then(function () {
                var url = cartService._masterDomain + '/' + $window.culture + '/account/login';

                $http({
                    method: 'POST',
                    url: url,
                    data: { email: email, password: password, token: token, expanded: expanded },
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    transformRequest: function (obj) {
                        //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                        var str = [];
                        for (var p in obj)
                            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                        return str.join("&");
                    },
                    withCredentials: true
                }).then(function (res) {
                    angular.copy(res.data, factory._account);
                    if (res.data.error != undefined && res.data.error.length == 0) {
                        
                        var expireDate = new Date();
                        expireDate.setDate(expireDate.getDate() + 7);
                        $cookies.put('accountToken', res.data.result.Token, {
                            path: '/' + culture,
                            'expires': expireDate,
                            secure: true,
                            samesite: 'none'
                        });
                        //$cookies.put('loginData', email, {
                        //    path: '/' + culture,
                        //    'expires': expireDate,
                        //    secure: true,
                        //    samesite: 'none'
                        //});

                        //push email to klaviyo
                        var preferences = $.gdprcookie.preference();
                        if (preferences.indexOf('statistics') > -1 && preferences.indexOf('marketing') > -1 && res.data.result.hasKlaviyoSubscription != null && res.data.result.hasKlaviyoSubscription == true) {
                            klaviyo.push(['identify', {
                                // Change the line below to dynamically print the user's email.
                                '$email': email
                            }]);
                            //var _learnq = _learnq || [];
                            //_learnq.push(['identify', { '$email': email }]);
                        }

                    } else {
                        if (res.data.result.Token == null) {
                            $cookies.remove('accountToken', { path: '/' + culture });
                            /*$cookies.remove('loginData', { path: '/' + culture });*/
                        }
                    }

                    def.resolve();
                });
            });
        }
        return def.promise;
    }

    factory.Logout = function () {
        //var def = $q.defer();
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/account/logoutajax';

            $http({
                method: 'GET',
                url: url,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                withCredentials: true
            }).then(function (res) {
                $cookies.remove('accountToken', { path: '/' + culture });
                $cookies.remove('loginData', { path: '/' + culture });
                location.reload();
                //def.resolve();
            });
        });
    }

    return factory;
}]);